module.exports = __webpack_public_path__ + "img/04.83cece15.jpg";